import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { usePortalLayout } from "./PortalLayout";
import { getClientePerfil } from "../../utils/peticionesApi";
import { MapPin, Clock, FileText, Bell, ShieldAlert, ClipboardCheck, LayoutDashboard, DoorOpen, FileCheck2 } from "lucide-react";

const SIDEBAR_ICONS = { RONDAS: MapPin, ASISTENCIA: Clock, SUPERVISION: FileText, EVENTOS: Bell, SIMULACROS: ShieldAlert, VISITAS: ClipboardCheck, ACCESOS: DoorOpen };

const SECTION_CONFIG = {
    RONDAS:      { label: "Rondas",                   section: "Operación",   order: 1 },
    ASISTENCIA:  { label: "Asistencia",               section: "Operación",   order: 1 },
    SUPERVISION: { label: "Actas de Visitas",         section: "Supervisión", order: 2 },
    VISITAS:     { label: "Visitas de Supervisores",  section: "Supervisión", order: 2 },
    EVENTOS:     { label: "Eventos de Seguridad",     section: "Seguridad",   order: 3 },
    SIMULACROS:  { label: "Simulacros",               section: "Seguridad",   order: 3 },
    ACCESOS:     { label: "Accesos",                  section: "Seguridad",   order: 3 },
};

export default function ClienteSidebarSetup({ children }) {
    const portalLayout = usePortalLayout();
    const navigate = useNavigate();
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if (!portalLayout || loaded) return;

        const buildSidebar = (modules) => {
            if (!modules || modules.length === 0) return;

            const sections = [{
                title: "Principal",
                items: [{
                    key: "DASHBOARD",
                    label: "Dashboard",
                    Icon: LayoutDashboard,
                    onClick: () => navigate("/clientes/dashboard"),
                }],
            }];

            const sectionMap = {};
            modules.filter((m) => SECTION_CONFIG[m]).forEach((mod) => {
                const cfg = SECTION_CONFIG[mod];
                if (!sectionMap[cfg.section]) {
                    sectionMap[cfg.section] = { title: cfg.section, order: cfg.order, items: [] };
                }
                sectionMap[cfg.section].items.push({
                    key: mod,
                    label: cfg.label,
                    Icon: SIDEBAR_ICONS[mod],
                    onClick: () => navigate("/clientes/dashboard"),
                });
            });

            // Directivas Particulares no depende de `modules` del cliente (es un flag por
            // empresa en el backend, no por usuario-cliente): siempre visible, con ruta
            // propia (no vuelve al dashboard como el resto). Si el visto bueno no está
            // habilitado para la empresa, el detalle igual se puede leer y el back explica
            // el error al intentar confirmarlo.
            if (!sectionMap["Supervisión"]) {
                sectionMap["Supervisión"] = { title: "Supervisión", order: SECTION_CONFIG.SUPERVISION.order, items: [] };
            }
            sectionMap["Supervisión"].items.push({
                key: "DIRECTIVAS",
                label: "Directivas Particulares",
                Icon: FileCheck2,
                onClick: () => navigate("/clientes/directivas"),
            });

            const moduleSections = Object.values(sectionMap).sort((a, b) => a.order - b.order);
            portalLayout.setSidebarSections([...sections, ...moduleSections]);
            setLoaded(true);
        };

        // Siempre usar API para modules (sessionStorage puede tener datos viejos del JWT)
        let cancelled = false;
        getClientePerfil()
            .then((res) => { if (!cancelled) buildSidebar(res?.data?.modules || []); })
            .catch(() => {
                if (cancelled) return;
                // Fallback: leer de sessionStorage si la API falla
                const data = sessionStorage.getItem("cliente_data");
                if (data) {
                    try {
                        const parsed = JSON.parse(data);
                        buildSidebar(parsed.modules || []);
                    } catch { /* ignore */ }
                }
            });

        return () => { cancelled = true; };
    }, [portalLayout, navigate, loaded]);

    return children;
}
